import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { ImageUrls } from "src/app/services/s3buket";
import { JobApplyService } from "../../job-apply/service/job-apply.service";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-applied-saved-jobs-item",
  templateUrl: "./applied-saved-jobs-item.component.html",
  styleUrls: ["./applied-saved-jobs-item.component.css"]
})
export class AppliedSavedJobsItemComponent implements OnInit {
  recuiterId:any;
  @Input() job: any;
  @Output() onJobSaved = new EventEmitter<any>();
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;

  constructor(public route: ActivatedRoute,private api: AdminService, private jobApplyService: JobApplyService) { }

  ngOnInit(): void {
    this.recuiterId = this.job.recruiter.id
    console.log("job----------", this.job.recruiter.id)  
  }

  applyJob() {
    // this.recuiterId = this.job?.recuiterId?.id
    this.jobApplyService.applyJob(this.job, this.recuiterId)
  }

  withdrawJob() {
    this.jobApplyService.withdrawJob(this.job.id);
  }

  public saveUnsaveJob() {
    if (this.job.saveStatus == 0) {
      this.api.postData(apiUrl._saveUnsaveJob, { "jobPostId": this.job.id }).subscribe((x) => {
        this.onJobSaved.emit(this.job);
      });
    } else {
      this.api.deleteData(apiUrl._saveUnsaveJob, { "jobPostId": this.job.id }).subscribe((x) => {
        this.onJobSaved.emit(this.job);
      });
    }
  }

  jobSalary(job: any): string {
    let salary = "";
    if (job?.price) salary = job?.price;
    else if (job?.maximum && job?.minimum) salary = job?.minimum + "-$" + job?.maximum;
    else salary = job?.minimum + job?.maximum;
    if (job?.rate) return "$" + salary + "/" + job?.rate.split(" ")[1];
    else return "$" + salary;
  }

  dateInMilisecond(date) {
    const d1 = new Date(date)
    const miliSecond = d1.getTime();
    return miliSecond
  }
}